import { JOURNAL_FORMS_ENDPOINT } from "api/endpoints";
import classNames from "classnames";
import { ButtonV2 } from "components/Button";
import Footer from "components/Footer";
import { FormField, FormFieldNative } from "components/Form";
import { Input, inputClassNames } from "components/Input";
import ModalWindow, { NamedModalWindow } from "components/ModalWindow";
import { Navbar } from "components/Navbar";
import { Textarea } from "components/Textarea";
import { useAPIFetch } from "hooks/fetch";
import { useUser } from "hooks/user";
import { genericToastErrorMessage } from "lib/errors";
import { Journal } from "models/journal";
import { Userv2 } from "models/user";
import Head from "next/head";
import { PropsWithChildren, useRef, useState } from "react";
import { useMutation } from "react-query";
import ReactSelect, { components as ReactSelectComponents } from "react-select";
import { toast } from "react-toastify";
import { twMerge } from "tailwind-merge";
import { handleFetchError } from "utils/fetch";
import { PropsWithClassAndStyle, PropsWithStyle } from "utils/props";
import InputMask from 'react-input-mask'
import { topicList } from 'data/journal-topics'
import { JournalEditModal } from "components/JournalEditModal";

function Section({ children, name }: PropsWithChildren<{ name: string }>) {
  return <div className="flex flex-col items-center gap-1">
    <h2 className="font-semibold text-xl">{name}</h2>
    <div>{children}</div>
  </div>
}

// function FormField({ name, children }: PropsWithChildren<{ name: string }>) {
//   return <div className="w-full">
//     <h4 className="font-semibold text-sm mb-0.5 text-dark-grey">
//       {name}
//     </h4>
//     {children}
//   </div>
// }

function RegisterForm({ close, user, initialData, onSubmit }: { close: () => void; initialData?: Journal; onSubmit: (j: Journal) => void; user?: Userv2 }) {
  const [title, setTitle] = useState(initialData?.name)
  const [titleEn, setTitleEn] = useState(initialData?.name_international)
  const [url, setUrl] = useState(initialData?.url)
  const [issn, setIssn] = useState(initialData?.issn)
  const [issnOnline, setIssnOnline] = useState(initialData?.issn_online)
  const [topics, setTopics] = useState<string[] | undefined>(initialData?.topics)
  const [rinz, setRinz] = useState<boolean | undefined>(initialData?.indexes?.rinz)
  const [coreRinz, setCoreRinz] = useState<boolean | undefined>()
  const [thumbnail, setThumbnail] = useState<string | undefined>(initialData?.thumbnail_url)
  const [guidelinesUrl, setGuidelinesUrl] = useState<string | undefined>(initialData?.guidelines_url)
  const thumbnailUploadRef = useRef<HTMLInputElement>(null)


  return <form className="flex flex-col gap-1 w-26 p-0.5 overflow-y-auto" onSubmit={e => {
    e.preventDefault()
    // onSubmit({
    //   name: title,
    //   name_international: titleEn,
    //   url,
    //   issn,
    //   issn_online: issnOnline,
    //   indexes: {
    //     vak,
    //     rinz,
    //     rinz_core: coreRinz,
    //   },
    //   thumbnail_url: thumbnail,
    //   guidelines_url: guidelinesUrl,
    //   topics,
    // } as Journal)
  }}>
    <div className="flex flex-row gap-1">
      <label className="p-0.5 border-grey border-2 border-dashed rounded-lg h-fit w-fit relative group">
        {thumbnail ? <>
          <div className="w-6 h-7 group-hover:brightness-50 bg-white rounded-lg" style={{ backgroundImage: `url('${thumbnail}')`, backgroundPosition: 'center center', backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }}></div>
          <button className="absolute group-hover:flex hidden h-full w-full items-center justify-center left-0 top-0" onClick={e => {
            e.preventDefault()
            thumbnailUploadRef.current?.click()
          }}>
            <img src="/images/blank-image-white.svg" className="w-2 h-2" />
          </button>
          <input hidden type="file" accept=".png,.svg,.jpg,.jpeg" ref={thumbnailUploadRef} onChange={async e => {
            e.preventDefault()
            const reader = new FileReader()
            reader.onloadend = () => {
              setThumbnail(reader.result as string)
            }
            if (e.target.files && e.target.files.length > 0) reader.readAsDataURL(e.target.files.item(0)!)
          }} name="thumbnail" />

        </> : <>
          <button className="flex-shrink-0 w-6 h-7 flex items-center justify-center" onClick={e => {
            e.preventDefault()
            thumbnailUploadRef.current?.click()
          }}>
            <img src="/images/blank-image.svg" className="w-2 h-2" />
          </button>
          <input hidden type="file" name="thumbnail" accept=".png,.svg,.jpg,.jpeg" ref={thumbnailUploadRef} onChange={async e => {
            e.preventDefault()
            const reader = new FileReader()
            reader.onloadend = () => {
              setThumbnail(reader.result as string)
            }
            if (e.target.files && e.target.files.length > 0) reader.readAsDataURL(e.target.files.item(0)!)
          }} />
        </>}
      </label>
      <div className="flex flex-col gap-1 w-full">
        <FormFieldNative name="Название" className="flex-1">
          <Input value={title} setValue={setTitle} placeholder="Название вашего журнала" name="name" className="w-full" />
        </FormFieldNative>
        <FormFieldNative name="Название (на английском)" className="flex-1">
          <Input value={titleEn} setValue={setTitleEn} placeholder="Название вашего журнала" name="name_international" className="w-full" />
        </FormFieldNative>
      </div>
    </div>
    <FormFieldNative name="URL" className="w-full">
      <Input value={url} setValue={setUrl} placeholder="https://example.com" className="w-full" type="url" name="homepage_url" />
    </FormFieldNative>
    <FormFieldNative name="URL правил журнала" className="w-full">
      <Input value={guidelinesUrl} setValue={setGuidelinesUrl} className="w-full" placeholder="https://example.com" type="url" name="guidelines_url" />
    </FormFieldNative>



    <FormFieldNative name="Тематика">
      <ReactSelect
        // tooltip="Стиль"
        isMulti
        options={topicList.map(v => ({ label: v[0], value: v[0], bold: v[1] }))}
        classNamePrefix="react-menu"
        value={topics ? topics.map(v => ({ label: v, value: v })) : undefined}
        onChange={v => {
          // console.log('tea', v)
          setTopics((v ?? []).map(v => v.value))
        }}
        menuPosition="fixed"
        placeholder="Выберите тематику вашего журнала"
        styles={{
          placeholder: (base, state) => ({
            ...base,
            color: 'var(--color-grey)',
          }),
          // singleValue: (styles, { data }) => ({
          //   ...styles,
          //   fontWeight: (data.bold ? 'bold' : undefined),
          // }),
          option: (styles, { data }) => ({
            ...styles,
            fontWeight: (data.bold ? '600' : undefined), // semibold; taken from https://tailwindcss.com/docs/font-weight
          })

        }}
        name="topic"
      />
    </FormFieldNative>


    {/* <div> */}
    {/*   <label> */}
    {/*     <input type="checkbox" checked={vak} onChange={e => setVak(e.target.checked)} className="align-middle accent-secondary" style={{ width: 16, height: 16 }} /> */}
    {/*     <span className="ml-0.2 text-dark-grey align-middle">Входит в&nbsp;перечень ВАК</span> */}
    {/*   </label> */}
    {/* </div> */}


    <div className="flex flex-row gap-1">
      <label className="flex-1">
        <input type="checkbox" checked={rinz} onChange={e => setRinz(e.target.checked)} className="align-middle accent-secondary" style={{ width: 16, height: 16 }} />
        <span className="ml-0.2 text-dark-grey align-middle">Индексируется в&nbsp;РИНЦ</span>
      </label>
      {rinz && <label className="flex-1">
        <input type="checkbox" checked={coreRinz} onChange={e => setCoreRinz(e.target.checked)} className="align-middle accent-secondary" style={{ width: 16, height: 16 }} />
        <span className="ml-0.2 text-dark-grey align-middle">Индексируется в&nbsp;ядре РИНЦ</span>
      </label>}
    </div>



    <div className="flex flex-row gap-1">
      <FormFieldNative name="ISSN (print)" className="flex-1">
        <InputMask value={issn} onChange={v => setIssn(v.target.value)} placeholder="0000-0000" mask="9999-9999" className={twMerge(inputClassNames, "flex-1 w-full")} name="issn" />
      </FormFieldNative>
      <FormFieldNative name="ISSN (online)" className="flex-1">
        <InputMask value={issnOnline} onChange={v => setIssnOnline(v.target.value)} placeholder="xxxx-xxxx" mask="****-****" className={twMerge(inputClassNames, "flex-1 w-full")} name="issn_online" />
      </FormFieldNative>
    </div>

    <div className="flex gap-1 flex-row w-full">
      <ButtonV2 type="reset" colorscheme="light" className="flex-1" onClick={close}>Отмена</ButtonV2>
      <ButtonV2 type="submit" className="flex-1" disabled={!title || !titleEn || !issn || !issnOnline || !thumbnail}>Далее</ButtonV2>
    </div>
  </form>
}

function FeatureCard({ icon, name, children, style, className, circlePosition, float }: PropsWithClassAndStyle<PropsWithChildren<{ name: string; icon: string; circlePosition?: { angle: number; radius: number }; float: 'right' | 'left' | 'below' }>>) {
  // const quadrantLayouts = ['row', 'col', 'row-inv', 'col']
  // if (circlePosition && !layout) {
  //   const normalized = circlePosition.angle % 360

  //   layout = quadrantLayouts[normalized / 90] as NonNullable<typeof layout>
  // }
  return <div className={twMerge("absolute", className)} style={{
    transform: float !== 'below' ?
      `translateX(${float === 'left' ? 52 : -48}px) translateY(-48px)` // Readjust when changing radius. Also no idea why they need to differ.
      : `translateX(-50%) translateY(-48px)`,
    transformOrigin: 'top left',
    ...style,
    ...(!!circlePosition ?
      float === 'left' ? {
        top: `calc(${circlePosition.radius / 2}px - ${circlePosition.radius}px / 2 * sin(${circlePosition.angle}deg))`,
        right: `calc(${circlePosition.radius / 2}px - ${circlePosition.radius}px / 2 * cos(${circlePosition.angle}deg))`,
      } : {
        top: `calc(${circlePosition.radius / 2}px - ${circlePosition.radius}px / 2 * sin(${circlePosition.angle}deg))`,
        left: `calc(${circlePosition.radius / 2}px + ${circlePosition.radius}px / 2 * cos(${circlePosition.angle}deg))`,
      } : {})
  }}>
    <span className={twMerge(classNames("flex flex-row gap-1 relative",
      { 'flex-row-reverse': float === 'left' },
      { 'flex-col items-center': float === 'below' }
    ))}>
      <div className="p-1 bg-white rounded-full h-fit w-fit">
        <img src={icon} width={24 * 2} height={24 * 2} alt={name} style={{ maxWidth: 'unset' }} />
      </div>
      <div className="flex flex-col gap-0.5">
        <h2 className={classNames("text-md font-semibold", {
          "text-right": float === 'left',
          "text-center": float === 'below',
        })}>{name}</h2>
        <p style={{ width: 500 }} className={classNames({
          "text-right": float === 'left',
          "text-center": float === 'below',
        }, "max-w-17")}>{children}</p>
      </div>
    </span>

    {/* <div className="relative"> */}
    {/* <div className="flex flex-col gap-0.5" style={invert ? {transform: 'translateX(calc(-100% - 48px - 48px - 24px - 24px))'} : {}}>  */}
    {/* </div> */}
  </div>
}

function Features() {
  const radius = 450 // If you change the radius, transform for left should also be tweaked. No idea why this happens, but play around and see what works.
  return <div className="flex justify-center items-center mb-10">
    <div style={{ width: radius, height: radius }} className="border-secondary border-2 width rounded-full relative">
      <FeatureCard name="Совместная работа над&nbsp;текстом" icon="/images/info/editors/collab-text.svg" circlePosition={{ radius, angle: 45 }} float="right">
        Используйте инструменты нашей платформы для&nbsp;удобной коллаборации с&nbsp;другими редакторами и&nbsp;авторами в&nbsp;реальном времени, обсуждая и&nbsp;внося изменения в&nbsp;текст
      </FeatureCard>
      <FeatureCard name="Предварительная экспертиза рукописей" icon="/images/info/editors/expertise-review.svg" circlePosition={{ radius, angle: 90 + 45 }} float="left">
        Получайте рукописи непосредственно от&nbsp;авторов для&nbsp;первичной оценки и&nbsp;формирования обратной связи согласно стандартам Вашего журнала
      </FeatureCard>
      <FeatureCard name="Управление исправлениями" icon="/images/info/editors/amendments-management.svg" circlePosition={{ radius, angle: 180 + 30 - 5 }} float="left">
        Просматривайте изменения, внесенные авторами после рецензирования, и&nbsp;управляйте процессом редактирования
      </FeatureCard>
      <FeatureCard name="Архивация и&nbsp;доступ" icon="/images/info/editors/cloud-archive.svg" circlePosition={{ radius, angle: 270 }} float="below">
        Сохраняйте и&nbsp;просматривайте архивированные статьи, что&nbsp;позволит Вам сохранять историю изменений и&nbsp;рецензирования для&nbsp;каждой работы
      </FeatureCard>
      <FeatureCard name="История версий рукописи" icon="/images/info/editors/article-versions.svg" circlePosition={{ radius, angle: 270 + 60 + 5 }} float="right">
        Вы&nbsp;легко отследите все версии документа и&nbsp;реакцию авторов на&nbsp;ваши комментарии, что&nbsp;значительно упрощает процесс оценки рукописи
      </FeatureCard>
    </div>
  </div>
}

export function ContactsForm({ back, onSubmit }: { back: () => void; onSubmit: (email: string, comment: string) => void }) {
  const [privacy, setPrivacy] = useState(false)
  const [email, setEmail] = useState('')
  return <form className="flex flex-col gap-1 w-20" onSubmit={e => {
    e.preventDefault()
    const fd = new FormData(e.currentTarget)

    onSubmit(fd.get("email") as string, fd.get("comment") as string)
  }}>
    <FormFieldNative name="Контактная почта">
      <Input type="email" name="email" placeholder="example@mail.ru" className="w-full" value={email} setValue={setEmail} />
    </FormFieldNative>
    <FormFieldNative name="Комментарий">
      <Textarea placeholder="Здесь вы можете оставить комментарий администрации Research Helper" name="comment" />
    </FormFieldNative>

    <div className="flex flex-col gap-0.5">
      <label>
        <input type="checkbox" className="mr-0.5" checked={privacy} onChange={e => setPrivacy(e.target.checked)} />
        С <a href="/privacy" target="_blank" className="underline text-secondary" rel="noreferrer">политикой конфиденциальности</a> согласен, условия персональных данных принимаю
      </label>
    </div>

    <div className="flex gap-1 flex-row w-full">
      <ButtonV2 type="reset" colorscheme="light" className="flex-1" onClick={back}>Назад</ButtonV2>
      <ButtonV2 type="submit" className="flex-1" disabled={!privacy || !email}>Отправить</ButtonV2>
    </div></form>
}


export default function Editors() {
  const [user] = useUser()
  const [formOpen, setFormOpen] = useState(0)
  const [journal, setJournal] = useState<Partial<Journal>>()

  const apiFetch = useAPIFetch()
  const handleSubmit = useMutation({
    mutationKey: 'editor-form',
    mutationFn: async (props: { journal: Partial<Journal>; email: string; comment: string }) => {
      return await handleFetchError(apiFetch(JOURNAL_FORMS_ENDPOINT, {
        method: 'POST',
        body: JSON.stringify({ ...props.journal, contact_email: props.email, comment: props.comment })
      }))
    },
    onSuccess: async () => {
      toast.success('Форма успешно отправлена')
      setFormOpen(0)
    },
    onError: async () => toast.error(genericToastErrorMessage)
  })
  return <>
    <Head>
      <title>Редакторы на&nbsp;Research Helper</title>
    </Head>
    <div>
      <Navbar user={user} static />
      <div className="flex flex-col items-center gap-4 pt-4">
        <div className="flex flex-col items-center gap-1">
          <h1 className="text-3xl text-center font-semibold">Редакторы на&nbsp;<span className="text-secondary">Research Helper</span></h1>
          <p className="text-center text-xl">Мы предусмотрели набор удобных инструментов для&nbsp;редакторов медицинских журналов<br />и издательств, позволяющих эффективно управлять рукописями и&nbsp;взаимодействовать с&nbsp;авторами</p>
        </div>
        <h2 className="font-semibold text-xl">Упростите процесс работы со&nbsp;статьей</h2>
        <Features />
        {/* <img src="/images/info/editor-cycle.svg" width={1474} height={895} /> */}
        <div className="flex flex-col gap-1 items-center">
          <h2 className="font-semibold text-xl">Станьте редактором уже сейчас</h2>
          <p className="text-center w-[50%]">Сотрудничая с&nbsp;нами, Вы&nbsp;получите доступ к&nbsp;широкой базе квалифицированных рецензентов, а&nbsp;также современные инструменты для&nbsp;обеспечения научной согласованности и&nbsp;точности оценки представленных работ</p>
          <ButtonV2 onClick={() => {
            if (user) setFormOpen(1)
            else toast.error('Для подачи заявки вы должы авторизироваться на платформе')
          }} className="flex flex-row items-center py-0.5">
            Зарегистрировать журнал
            <img src="/images/arrow-right-full.svg" width={16} height={16} className="ml-[10px]" />
          </ButtonV2>
        </div>
        <div className="h-2"></div>
        {/* <NamedModalWindow open={!!formOpen} close={() => setFormOpen(0)} contentLabel="form" className="bg-white items-center h-[80vh]" titleClassName="w-full" name="Данные журнала"> */}
          <JournalEditModal
            title={"Регистрация журнала"}
            submitText={'Далее'}
            open={formOpen === 1}
            close={() => setFormOpen(0)}
            // initialData={journal}
            onSubmit={v => {
              const reader = new FileReader();

              const { thumbnail, ...journal } = v
              reader.onloadend = () => {
                console.log(reader.result);
                setJournal({ ...journal, thumbnail_url: reader.result as string })
                setFormOpen(2)
              };
              reader.readAsDataURL(thumbnail!);
            }} />

          {/* {formOpen === 1 && <RegisterForm */}
          {/*   close={() => setFormOpen(0)} */}
          {/*   // initialData={journal} */}
          {/*   onSubmit={v => { */}
          {/*     setFormOpen(2) */}
          {/*     setJournal(v) */}
          {/*   }} user={user} data-test="register" />} */}
        <NamedModalWindow open={formOpen == 2} close={() => setFormOpen(0)} contentLabel="form" className="bg-white items-center flex" titleClassName="w-full" name="Данные журнала">
          {formOpen === 2 && <ContactsForm
            back={() => setFormOpen(1)}
            onSubmit={(email, comment) => handleSubmit.mutate({ journal: journal!, email, comment })} data-test="contacts" />}
        </NamedModalWindow>
      </div>
      <Footer />
    </div>
  </>
}
